import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Typography } from '@material-ui/core';
import { Form } from '@unform/web';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Hidden,
} from '~/components/Form';
import { ConfirmationDialogRawNew } from '~/componentsLocal';
import { TRR_CHILE } from '~/constants/modules';
import { t, can, canURL } from '~/helpers';
import { deletarClienteOperacaoAbastecimento } from '~/store/modules/operacaoabastecimento/actions';

import * as S from './styles';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();
  const permission = canURL();
  const [loadingScreen, setloadingScreen] = useState(false);
  const [posto, setPosto] = useState(0);
  const [veiculo, setVeiculo] = useState(null);
  const [idTipoMovimentacao, setIdTipoMovimentacao] = useState(0);
  const { client } = useSelector((state) => state.user.profile);
  const { internounidatausuario, formaidfrentistaabast } = useSelector(
    (state) => state.user.configs
  );
  const { loading, find, params } = useSelector(
    (state) => state.operacaoabastecimento
  );
  // ConfirmationDialogRaw o registro do geral
  const [isLoading, setIsLoading] = useState(false);
  const [
    tituloConfirmationDialogRaw,
    setTituloConfirmationDialogRaw,
  ] = React.useState('Deseja excluir o registro');
  const [
    mensagemConfirmationDialogRaw,
    setMensagemConfirmationDialogRaw,
  ] = React.useState('Confirma exclusão do registro?');
  const [
    openConfirmationDialogRaw,
    setOpenConfirmationDialogRaw,
  ] = React.useState(false);
  const [
    valueConfirmationDialogRaw,
    setValueConfirmationDialogRaw,
  ] = React.useState('CLICK-OK');
  const [paramSubmit, setParamSubmit] = React.useState();

  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  255,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 255)
                )
            : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objParam = { ...param };

      const objSend = {
        volumepredeterminadomovimentacao: '100',
        modomovimentacao: '0',
        formaidmovimentacao: '0',
        idmovimentacao: '0',
        tipomovimentacao: '0',
        numerologmovimentacao: '0',
        onlinemovimentacao: '0',
        precounitariomovimentacao: '0.0',
        vazaomediamovimentacao: '0.0',
        vazaomaximamovimentacao: '0.0',
        idcentrocusto: '',
        idcontrato: '',
        codigousuario: '',
        totalizadoranteriormovimentacaoabastecimento: '0.0',
        totalizador2anteriormovimentacaoabastecimento: '0.0',
        totalizadorconfirmadomovimentacaoabastecimento: '0.0',
        contingenciamovimentacaoabastecimento: '0',
        ...initials,
        ...objParam,
        codigousuario: initials.codigousuario,
        idoperacao: initials.idoperacao,
        totalizadormovimentacaoabastecimento:
          initials.totalizadormovimentacaoabastecimento,
        totalizador2movimentacaoabastecimento:
          initials.totalizador2movimentacaoabastecimento,
        idcliente: client,
        densidade20movimentacao: 0.0,
        volume20movimentacao: 0.0,
        temperaturamediamovimentacao: 0.0,
        idveiculo: veiculo,
      };
      dispatch(deletarClienteOperacaoAbastecimento(objSend, params));
    } catch (err) {
      setloadingScreen(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted && !isEmpty(find)) {
      const { idposto, tipomovimentacao } = find;
      if (!create) {
        setIdTipoMovimentacao(tipomovimentacao || 0);
        setPosto(idposto);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  const execHandleConfirmar = async (param) => {
    setParamSubmit(param);
    setOpenConfirmationDialogRaw(true);
  };

  async function handleSubmitPegunta(param) {
    // await setIsLoading(true);
    // await execHandleConfirmar(param);

    try {
      const schema = Yup.object().shape({
        justificativa:
          idTipoMovimentacao !== 0
            ? Yup.string()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
                .max(
                  300,
                  t('s.geral.validacao.tamanhomaximo').replace('%s', 300)
                )
            : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      await setIsLoading(true);
      await execHandleConfirmar(param);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  const handleConfirmationDialogRaw = (newValue) => {
    // console.log(newValue);
    setOpenConfirmationDialogRaw(false);
    if (newValue) {
      setValueConfirmationDialogRaw(newValue);
      setIsLoading(false);
      if (newValue === 'CLICK-OK') {
        setIsLoading(true);
        handleSubmit(paramSubmit);
      }
    } else {
      // cancelarAcao();
      setIsLoading(false);
    }
  };

  return (
    <>
      <>
        {' '}
        {/* <> Para confirmação do form */}
        <ConfirmationDialogRawNew
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmationDialogRaw}
          onClose={handleConfirmationDialogRaw}
          valueProp={valueConfirmationDialogRaw}
          mensagem={mensagemConfirmationDialogRaw}
          titulo={tituloConfirmationDialogRaw}
          textoBtnOK="Sim"
          textoBtnCancel="Não"
          modal="sm"
        />
      </>{' '}
      {/* <> Para confirmação do form */}
      {loading | loadingScreen ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form
          ref={reference}
          initialData={initials}
          onSubmit={(event) => handleSubmitPegunta(event)}
        >
          <S.Header>
            <Typography variant="h6">
              Exclusão de registro pelo usuário
            </Typography>
          </S.Header>

          {idTipoMovimentacao === 0 ? (
            <>
              <S.Header>
                <Typography variant="h7" color="primary">
                  ATENÇÃO: Este registro é manual
                </Typography>
              </S.Header>
              <Hidden
                name="justificativa"
                label="Justificativa"
                value="Registro é manual"
              />
            </>
          ) : (
            <>
              <S.Header>
                <Typography variant="h7" color="error">
                  ATENÇÃO: Este registro foi gerado pelo terminal
                </Typography>
              </S.Header>
              <Input
                multiline
                name="justificativa"
                label="Justificativa"
                rows={4}
              />
            </>
          )}

          {idTipoMovimentacao === 0 ? (
            <S.Header>
              <Typography variant="h5" color="primary" />
            </S.Header>
          ) : (
            <>
              <Autocomplete
                name="idposto"
                disabled
                disableClearable={!create}
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.menu.configuracao.posto')}
                getValue={(value) => {
                  // handleChangepostoscomboios(value);
                }}
              />

              <Combobox
                name="idbico"
                disabled
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: !create
                    ? ['idposto', 'tipoproduto']
                    : [
                        'idposto',
                        'tipoproduto',
                        'bloqueiadigitacaomovimentacaobico',
                      ],
                  valuewherefield: !create
                    ? [posto ?? find.idposto, 'C']
                    : [posto ?? find.idposto, 'C', 'S'],
                  typewherefield: !create
                    ? ['EQUALS', 'EQUALS']
                    : ['EQUALS', 'EQUALS', 'EQUALS'],
                  fieldlist:
                    'idbico, idterminal, idproduto, bicoprodutobico, exibemotoristaterminal, diasliberadigitacaomovimentacaobico',
                }}
                getValue={(value) => {}}
              />

              <>
                <DateTime
                  time
                  name="datahorainicialmovimentacao"
                  disabled
                  label={t(
                    's.operacao.abastecimento.datahorainicialmovimentacao'
                  )}
                />
                <DateTime
                  time
                  name="datahorafinalmovimentacao"
                  disabled
                  label={t(
                    's.operacao.abastecimento.datahorafinalmovimentacao'
                  )}
                />
              </>

              <Input
                name="idveiculo"
                disabled
                onInputChange={(event, newValue) => {
                  setVeiculo(newValue);
                }}
                onChange={(event) => setVeiculo(event.target.value)}
                label={
                  !can(TRR_CHILE)
                    ? t('s.operacao.abastecimento.idveiculo')
                    : t('s.cadastro.codigoempresacliente')
                }
                getValue={(value) => setVeiculo(value)}
              />

              <Input
                name="volumemovimentacao"
                disabled
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />
            </>
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  toggleLoading: PropTypes.func.isRequired,
};

CreateOrUpdate.defaultProps = {
  data: {},
};
